import { render, staticRenderFns } from "./BannedWordCreated.vue?vue&type=template&id=62ab681e&scoped=true"
import script from "./BannedWordCreated.vue?vue&type=script&lang=js"
export * from "./BannedWordCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ab681e",
  null
  
)

export default component.exports